var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-80x80 max-80x80"},[_c('img',{class:'text-telkom-blue' + _vm.imgClass || 'max-80x80',attrs:{"src":_vm.imgSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }